export default {"src":"/_next/static/image/public/images/ic_copy_green.c6b9e6d503f5d7e259f3ed66425fc579.svg","height":16,"width":15};